<template>
    <div class="stepEightRoot">
      <!-- <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div> -->

        <!-- <div>
            <div class="titleLine">Please leave your email</div>
            <div class="subTitle">We’ll analyze your responses (takes about 30 seconds). If you’re short on time, we’ll also send the results directly to your inbox.</div>

        </div> -->
        <!-- <div class="oneLine">Preprint Timing</div>
        
        <div class="twoLine">Uploading a preprint with your camera-ready version can boost visibility and increase chances of becoming Highly Cited within the same year.</div>
   
        <div class="threeLine">Reviewer Opportunities</div> -->

      <!-- <div class="textBox" >
        <div class="textBlock">
          <div class="titleText">📄 Preprint Timing</div>
          <div class="contentText">Uploading a preprint with your camera-ready version can boost visibility and increase chances of becoming Highly Cited within the same year. </div>
        </div>

        <div class="textBlock">
          <div class="titleText">🧑‍⚖️ Reviewer Opportunities</div>
          <div class="contentText">Web of Science lets researchers apply as reviewers across many journals. We offer a step-by-step guide to help you through it.</div>
        </div>

        <div class="textBlock">
          <div class="titleText">📬 Outreach Insights</div>
          <div class="contentText">Academic outreach sees about 1 reply per 20 messages. A higher rate suggests your work is resonating. </div>
        </div>

        <div class="textBlock">
          <div class="titleText">🚀 Stay Competitive</div>
          <div class="contentText">n computer vision, publication can take 5+ months. Posting a preprint early helps gain citations before formal release.</div>
        </div>
      </div> -->
      <div class="loading-container textBox">
        <div  v-if="showFirstText"    class="animate__animated"  :class="firstTextAnimation" >         
           <div class="titleText">{{typeData[0].title}}</div>
           <div class="contentText">{{typeData[0].content}}</div>
        </div>
        <div v-if="showSecondText"   class="animate__animated"  :class="secondTextAnimation" >
          <div class="titleText">{{typeData[1].title}}</div>
           <div class="contentText">{{typeData[1].content}}</div>
        </div>
        <div v-if="showThirdText"   class="animate__animated"  :class="ThirdTextAnimation" >
          <div class="titleText">{{typeData[2].title}}</div>
           <div class="contentText">{{typeData[2].content}}</div>
        </div>
        <div v-if="showFourText"   class="animate__animated"  :class="FourTextAnimation" >
          <div class="titleText">{{typeData[3].title}}</div>
           <div class="contentText">{{typeData[3].content}}</div>
        </div>
      </div>

      <div class="progressBlock">
        <el-progress  :text-inside="true" :stroke-width="32" :percentage="persentVal" status="warning"></el-progress>
      </div>

      <div class="btnLine" v-if="typeItCompltetd">
          <!-- <div class="disBtn" v-if="!inputEmali">Next step</div> -->
          <div class="chooseBtn"  @click="goToNextStep">Next</div>
      </div>
      <div class="LastLine2">
          <div class="oneItem">©  2012-2026 PaperSpotlight. All rights reserved.</div>
          <!-- <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div> -->
      </div>
    </div>
</template>
<script>
import CircleVue from './circle.vue'
import TypeIt from "typeit"
import BackPageVue from './backPage.vue'

import 'animate.css';

export default {
    components:{CircleVue,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
       
        inputEmali:'',
        typeItInstance: null, // 存储 TypeIt 实例
        typeItCompltetd:false,
        typeData:[
          {title:'📄 Preprint Timing',content:'Uploading a preprint with your camera-ready version can boost visibility and increase chances of becoming Highly Cited within the same year. '},
          {title:'🧑‍⚖️ Reviewer Opportunities',content:'Web of Science lets researchers apply as reviewers across many journals. We offer a step-by-step guide to help you through it.'},
          {title:'📬 Outreach Insights',content:'Academic outreach sees about 1 reply per 20 messages. A higher rate suggests your work is resonating. '},
          {title:'🚀 Stay Competitive',content:'In computer vision, publication can take 5+ months. Posting a preprint early helps gain citations before formal release. '}
        ],
        showFirstText: true,
        showSecondText: false,
        showThirdText: false,
        showFourText: false,
        firstTextAnimation: 'animate__fadeInUp',
        secondTextAnimation: 'animate__fadeInUp',
        ThirdTextAnimation: 'animate__fadeInUp',
        FourTextAnimation: 'animate__fadeInUp',
        persentVal:0
      }
  },
  mounted() {
    let timer = setInterval(()=>{
      let value = this.persentVal
      let randomNumber = Math.floor(Math.random() * 11); // 返回0到10的整数
      value += randomNumber
      if(value<98){
        this.persentVal =  value
      }
    },500)

    setTimeout(() => {
      console.log(111111)
      this.firstTextAnimation = 'animate__fadeOutUp';
    }, 3000);
    setTimeout(() => {
      console.log(222222)
        this.showFirstText = false;
        this.showSecondText = true;
    }, 3500); 

    setTimeout(() => {
      console.log(333)
      this.secondTextAnimation = 'animate__fadeOutUp';
    }, 6500); // 等待消失动画完成
    setTimeout(() => {
      console.log(4444)
      this.showSecondText = false
      this.showThirdText = true
    }, 7000); // 等待消失动画完成
    setTimeout(() => {
      console.log(555)
      this.ThirdTextAnimation = 'animate__fadeOutUp';
    }, 10000);
    setTimeout(() => {
      console.log(666)
      this.showThirdText = false
      this.showFourText = true
    }, 10500);
    setTimeout(() => {
      console.log(555)
      this.persentVal =100
      clearInterval(timer);
      // this.FourTextAnimation = 'animate__fadeOutUp';
    }, 12000);
    setTimeout(() => {
      this.goToNextStep()
      // this.FourTextAnimation = 'animate__fadeOutUp';
    }, 13500);
    
  },
  methods:{
    hanldGoBack(){
      localStorage.setItem('guideIndex', 7);
      this.$emit('changePage', 7);
    },
    goToNextStep(index){
      localStorage.setItem('guideIndex', 9);
      this.$emit('changePage', 9);

    },
  
  },
  beforeDestroy() {
  
  },
}
</script>

<style>
.typeIt-completed .ti-cursor {
  display: none !important;
}


  .progressBlock .el-progress.is-warning .el-progress-bar__inner{
    background-color:#feae00!important
  }
  .progressBlock  .el-progress__text i{
    display: none;
  }
  .progressBlock .el-progress-bar__innerText{
    color: #fff !important;
  }
</style>
<style lang="scss">

.stepEightRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0 30px 0;
    gap: 50px;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 600px;
        color: var(---2, #333);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .oneLine{
      color: var(---1, #E0E0E0);
      text-align: center;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .twoLine{
      max-width: 1000px;
      color: var(---3, #999);
      text-align: center;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .threeLine{
      color: #000;
      text-align: center;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .textBox{
      width: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding: 40px 0;
      gap: 40px;
      position: absolute;;
      bottom: 200px ;
      .titleText{
        //text-align: center;
        color: var(---3, #000);
        font-size: 50px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
      }
      .contentText{
        margin-top: 10px;
        //text-align: center;
        color: var(---3, #000);
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
      }
    }
    .progressBlock{
        width: 300px;
        position: absolute;;
        right: 50px;
        bottom: 100px ;
      .el-progress-bar__innerText{
        font-size: 20px !important;
      }
      .el-progress-bar__outer{
        height: 32px !important;
      }
    }
    
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
      flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      .skipBtn{
          cursor: pointer;
          padding: 12px 40px;
            font-size: 16px;
            color: #999;
        }
    }
    .LastLine2{
      flex: 1 1;
      display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -20px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
@media screen and (max-width:767px) { 
  .stepEightRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20vw 6vw 10vw 6vw;
  gap: 6vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 100%;
        color: var(---2, #333);
        text-align: center;
        font-size: 3.4vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .oneLine{
      color: var(---1, #E0E0E0);
      text-align: center;
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .twoLine{
      max-width: 1000px;
      color: var(---3, #999);
      text-align: center;
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .threeLine{
      color: #000;
      text-align: center;
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .textBox{
      width: 87vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      left: 6vw;
      right: 6vw;
      bottom: 35vw ;
      .titleText{
        // text-align: center;
        color: var(---3, #000);
        font-size: 4vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
      }
      .contentText{
        margin-top: 2vw;
        // text-align: center;
        color: var(---3, #000);
        font-size: 4vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
      }
    }
    .progressBlock{
        width: 87vw;
        position: absolute;;
        right: 6vw;
        left: 6vw;
        bottom: 18vw ;
        .el-progress-bar__innerText{
          font-size: 4vw !important;
        }
        .el-progress-bar__outer{
          height: 6vw !important;
        }
    }
    
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
      flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 3.4vw;
            color: #999;
        }
    }
    .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -4vw;
        .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
    }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepEightRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6vw 0 3vw;
    gap: 5vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 600px;
        color: var(---2, #333);
        text-align: center;
        font-size: 1.6vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .oneLine{
      color: var(---1, #E0E0E0);
      text-align: center;
      font-size: 4vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .twoLine{
      max-width: 80%;
      color: var(---3, #999);
      text-align: center;
      font-size: 4vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .threeLine{
      color: #000;
      text-align: center;
      font-size: 4vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .textBox{
      width: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding: 40px 0;
      gap: 4vw;
      position: absolute;;
      bottom: 20vw ;
      .titleText{
        //text-align: center;
        color: var(---3, #000);
        font-size: 5vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
      }
      .contentText{
        margin-top: 10px;
        //text-align: center;
        color: var(---3, #000);
        font-size: 3vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
      }
    }
    .progressBlock{
        width: 30vw;
        position: absolute;;
        right: 5vw;
        bottom: 10vw ;
      .el-progress-bar__innerText{
        font-size: 2.2vw !important;
      }
      .el-progress-bar__outer{
        height: 3.2vw !important;
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
      flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 1.6vw;
            color: #999;
        }
    }
    .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -1vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
}
</style>